"use client";
import { HTMLAttributes, FC, useState, useRef, useEffect } from "react";
import { Progress } from "../components";
import { YolkLogo } from "./logo";
import { cn } from "../lib/utils";

type TrainingLoaderProps = HTMLAttributes<HTMLDivElement> & {
  fullscreen?: boolean;
};

export const createPseudoProgress = (cb: (num: number) => void) => {
  let step = 0.2;
  let progress = 0;
  let current_progress = 0;
  let interval: ReturnType<typeof setInterval> | null = null;
  let started = false;

  const start = () => {
    started = true;
    interval = setInterval(() => {
      current_progress += step;
      progress = Math.round(
        Math.floor((Math.atan(current_progress) / (Math.PI / 2)) * 100 * 1100) /
        1000,
      );
      if (progress >= 100) {
        if (interval) {
          clearInterval(interval);
        }
      } else if (progress >= 99) {
        step = 0.2;
      }
      if (progress < 100) {
        cb(progress);
      } else {
        cb(99);
        if (interval) clearInterval(interval);
      }
    }, 500);
  };
  const clear = () => {
    started = false;
    cb(100);
    if (interval) clearInterval(interval);
  };
  return {
    start,
    clear,
    started,
  };
};

export const TrainingLoader: FC<TrainingLoaderProps> = ({
  fullscreen = true,
  ...props
}) => {
  const [value, setValue] = useState(0);
  const progress = useRef(createPseudoProgress(setValue));

  useEffect(() => {
    const _progress = progress.current;
    if (!_progress.started) {
      _progress.start();
    }
    return () => {
      setValue(0);
      _progress.clear();
    };
  }, []);
  return (
    <div
      className={cn(
        "w-full h-full flex flex-col items-center justify-center",
        fullscreen && "z-50 bg-[#fffef2] fixed top-0 left-0",
      )}
      {...props}
    >
      <div className="w-[72px] h-[72px] mb-12">
        <YolkLogo progress={value} />
      </div>
      <Progress color="#F1CD10" value={value} className="w-[320px] mb-4" />
      <span className="text-[#5b5540] text-sm font-medium">
        Gathering insights...
      </span>
    </div>
  );
};
